import React from 'react';
import { HeaderGroup } from '@tanstack/react-table';
import { DataGridHeader } from '../DataGridHeader';

export type DataGridHeaderGroupProps = {
  group: HeaderGroup<unknown>;
  headerStyle?: React.CSSProperties;
};
export const DataGridHeaderGroup: React.FC<DataGridHeaderGroupProps> = ({
  group,
  headerStyle,
}) => {
  return (
    <>
      <tr key={group.id}>
        {group.headers.map((header, index) => (
          <DataGridHeader key={`${header.id}-${index}`} header={header} headerStyle={headerStyle} />
        ))}
      </tr>
    </>
  );
};
